"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { cloneElement, Children, Component } from "react";
import classNames from "classnames";
import { TabsContext } from "./Tabs";
import { TransitionGroup, Transition } from "react-transition-group";
import { AnimationDuration } from "../../../styles/Animations";
import forceReflow from "../../../utils/forceReflow";
var TabPanels = /*#__PURE__*/function (_Component) {
  _inherits(TabPanels, _Component);
  var _super = _createSuper(TabPanels);
  function TabPanels() {
    var _this;
    _classCallCheck(this, TabPanels);
    _this = _super.apply(this, arguments);
    _this.getDirection = function (child) {
      var _this$context = _this.context,
        selectedIndex = _this$context.selectedIndex,
        prevSelectedIndex = _this$context.prevSelectedIndex;
      if (selectedIndex > prevSelectedIndex) return child.props.in ? 1 : -1;
      return child.props.in ? -1 : 1;
    };
    return _this;
  }
  _createClass(TabPanels, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        transitionHeight = _this$props.transitionHeight;
      var _this$context2 = this.context,
        selectedIndex = _this$context2.selectedIndex,
        panelHeight = _this$context2.panelHeight,
        animating = _this$context2.animating;
      var panelsHeight = transitionHeight && panelHeight !== 0 ? panelHeight : void 0;
      return /* @__PURE__ */React.createElement("div", {
        className: classNames("tabs__tab-panels", className, {
          "tabs__tab-panels--animating": animating
        }),
        style: {
          height: panelsHeight
        }
      }, /* @__PURE__ */React.createElement(TransitionGroup, {
        component: null,
        childFactory: function childFactory(child) {
          return cloneElement(child, {
            direction: _this2.getDirection(child)
          });
        }
      }, Children.toArray(children).filter(Boolean).map(function (child, index) {
        return index === selectedIndex && /* @__PURE__ */React.createElement(Transition, {
          key: "tab-panel-".concat(index),
          timeout: AnimationDuration.Short,
          onEnter: forceReflow
        }, function (status, _ref) {
          var direction = _ref.direction;
          return cloneElement(child, {
            index: index,
            status: status,
            direction: direction
          });
        });
      })));
    }
  }]);
  return TabPanels;
}(Component);
TabPanels.contextType = TabsContext;
export default TabPanels;